import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { HelmetProvider } from "react-helmet-async";
import { initAnalytics } from '@/lib/analytics';

// Microsoft Clarity + Google Analytics (load only when their env ids are set).
initAnalytics();

createRoot(document.getElementById('root')!).render(
  <HelmetProvider>
    <StrictMode>
       <App />
    </StrictMode>
  </HelmetProvider>
 
);
